@import 'src/styles/common/_colors.scss';
.searchBox {
    [class*="searchContainer"] {
        width: 100%;
        [class*="searchWrapper"] {
            width: 100%;
            [class*="iconSearch"] {
                top: 7px !important;
            }
            [class*="clearInput"] {
                top: 13px !important;
                right: 10px;
                font-size: 14px;
            }
            input {
                width: 100%;
            }
        }  
    }
}

.dropdownMenu {
    background-color: $gray-variant-6 !important;
    width: 300px;
    height: 300px;
    padding: 5px;
}

.menuWrapper {
    display: flex; 
    flex-direction: column;
    height: 100%;
}

.ddToggle {
    max-width: 230px;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis
}

.infiniteWrapper {
    overflow: auto;
    padding: 3px 0px;
}
